var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFeat4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#58F2A9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.904 21.563C11.9572 21.8019 12.0822 22.0189 12.2621 22.1847C12.4421 22.3506 12.6685 22.4574 12.911 22.491C13.1535 22.5245 13.4004 22.4831 13.6186 22.3722C13.8369 22.2614 14.016 22.0865 14.132 21.871L16.222 18.778L21.129 23.685C21.2281 23.7841 21.3457 23.8627 21.4752 23.9163C21.6046 23.9699 21.7434 23.9975 21.8835 23.9975C22.0236 23.9975 22.1624 23.9699 22.2918 23.9163C22.4213 23.8627 22.5389 23.7841 22.638 23.685L23.685 22.638C23.7841 22.5389 23.8627 22.4213 23.9163 22.2918C23.9699 22.1624 23.9975 22.0236 23.9975 21.8835C23.9975 21.7434 23.9699 21.6046 23.9163 21.4752C23.8627 21.3457 23.7841 21.2281 23.685 21.129L18.778 16.222L21.891 14.132C22.1065 14.0159 22.2814 13.8367 22.3921 13.6184C22.5029 13.4001 22.5442 13.1531 22.5106 12.9106C22.477 12.6682 22.37 12.4418 22.204 12.2618C22.038 12.0819 21.821 11.957 21.582 11.904L8 8L11.904 21.563Z",
    stroke: "#1ED760",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat4);
export default __webpack_public_path__ + "static/media/feat4.68f69ec33f01884e4f96bbc89667e5c7.svg";
export { ForwardRef as ReactComponent };